export default __webpack_public_path__ + "static/media/home.b3c50e09.svg";